export default "__VITE_ASSET__BUxpTI03__"